var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutDefault',[_c('div',{staticClass:"my-profile"},[_c('ProfileForm'),(_vm.canUseMenuEngineering)?_c('ProfileRestaurants'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }